"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const change_case_1 = require("change-case");
const react_1 = tslib_1.__importDefault(require("react"));
const react_hanger_1 = require("react-hanger");
const react_loops_1 = require("react-loops");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const User_1 = require("./User");
const IS_ACTIVE_STATUSES = {
    false: 'inactive',
    null: 'all',
    true: 'active',
};
exports.Users = ({ workspace }) => {
    const { state, setState } = react_hanger_1.useSetState({
        cachedSearchInput: '',
        isActive: null,
        searchDropdownIsOpen: false,
        showInviteForm: false,
    });
    const searchInput = react_hanger_1.useInput('');
    react_1.default.useEffect(() => {
        const timeout = setTimeout(() => setState({
            cachedSearchInput: searchInput.value,
        }), 200);
        return () => {
            clearTimeout(timeout);
        };
    }, [searchInput.value, setState]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "mb-2" },
            react_1.default.createElement(reactstrap_1.InputGroup, null,
                react_1.default.createElement(reactstrap_1.Input, Object.assign({}, searchInput.eventBind, { placeholder: "Search user names or email addresses" })),
                react_1.default.createElement(reactstrap_1.InputGroupButtonDropdown, { addonType: "append", isOpen: state.searchDropdownIsOpen, toggle: () => {
                        setState({
                            searchDropdownIsOpen: !state.searchDropdownIsOpen,
                        });
                    } },
                    react_1.default.createElement(reactstrap_1.DropdownToggle, { outline: true, color: "primary" },
                        change_case_1.titleCase(IS_ACTIVE_STATUSES[state.isActive], 'en-us'),
                        "users",
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: !state.searchDropdownIsOpen ? pro_solid_svg_icons_1.faCaretDown : pro_solid_svg_icons_1.faCaretUp })),
                    react_1.default.createElement(reactstrap_1.DropdownMenu, null,
                        react_1.default.createElement(reactstrap_1.DropdownItem, { header: true }, "Membership Status"),
                        react_1.default.createElement(react_loops_1.For, { in: IS_ACTIVE_STATUSES }, (item, { key }) => {
                            return (react_1.default.createElement(reactstrap_1.DropdownItem, { active: state.isActive === key, onClick: () => {
                                    setState({
                                        isActive: key,
                                    });
                                } },
                                react_1.default.createElement("span", null,
                                    change_case_1.titleCase(item, 'en-us'),
                                    " "),
                                react_1.default.createElement("span", null, " users")));
                        }))))),
        react_1.default.createElement(reusables_1.QueryList, { itemName: "user", itemsKey: "workspaceMemberships", countKey: "workspaceMembershipsCount", item: User_1.User, queryVariables: {
                isActive: state.isActive === 'false'
                    ? [false]
                    : state.isActive === 'true'
                        ? [true]
                        : undefined,
                searchQuery: state.cachedSearchInput,
                workspaceId: workspace.id,
            }, queryProps: {
                fetchPolicy: 'cache-and-network',
                query: graphql_1.workspaceMemberships,
            } })));
};
//# sourceMappingURL=Users.js.map